"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: ["page-wrap", _vm.customClassName]
  }, [_c("el-pagination", _vm._b({
    attrs: {
      "current-page": _vm.page.currentPage,
      "page-size": _vm.page.size,
      total: _vm.page.total,
      "page-sizes": _vm._pageConfig.pageSizes,
      layout: _vm._pageConfig.layout
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }, "el-pagination", _vm.elAttrs, false))], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;